const common = {
  add: '添加',
  edit: '编辑',
  delete: '删除',
  save: '保存',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  cancel: '取消',
  close: '关闭',
  confirm: '确认',
  tip: '提示',
  warning: '警告',
  required: '{field}不能为空',
  reset: '重置',
  refresh: '刷新',
  min: '最小值',
  back: '返回',
  max: '最大值',
  select: '请选择',
  selected: '已选',
  items: '项',
  yes: '是',
  no: '否',
  unlimited: '不限',
  clear: '清空',
  expand: '展开',
  pin: '置顶',
  unpin: '取消置顶',
  pinSuccess: '置顶成功',
  unpinSuccess: '取消置顶成功',
  operationFailed: '操作失败',
  operationSuccess: '操作成功 {count} 条',
  batchAdd: '批量添加',
  batchTransfer: '批量转移',
  batchDelete: '批量删除',
  batchActions: '批量操作',
  filter: '筛选',
  operations: '操作',
  total: '共',
  previous: '上一页',
  next: '下一页',
  send: '发送',
  sending: '发送中...',
  more: '更多',
  search: '搜索',
  loading: '加载中',
  noData: '暂无数据',
  copyToClipboard: '点击复制',
  like: '赞',
  dislike: '踩',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  unknown: '未知',
  justNow: '刚刚',
  hoursAgo: '{count}小时前',
  daysAgo: '{count}天前',
  retry: '重试',
}

export default common
